import {
    setSession
} from '@/utils/getsession';
import {
    Message
} from 'element-ui';
export default {
    namespaced: true,
    actions: {
        async format(context, data) {
            try {
                const {
                    formatData
                } = await import('@/utils/IPConversion');
                const formattedValue = formatData(data.formatList, data.type, data.port, data.isStaticNode);
                let formatList = []

                if (!data.formatList.isl2) {
                     formatList = [{
                            label: "socks格式",
                            value: formattedValue.wanAn,
                        },
                        {
                            label: "http格式",
                            value: formattedValue.http,
                        },
                        {
                            label: "指纹浏览器",
                            value: formattedValue.fingerprint,
                        },

                    ]
                } else {
                     formatList = [
                        {
                            label: "socks格式",
                            value: formattedValue.wanAn,
                        },
                        {
                            label: "http格式",
                            value: formattedValue.http,
                        },
                        {
                            label: "指纹浏览器",
                            value: formattedValue.fingerprint,
                        },
                        {
                            label: "L2TP格式(666666为秘钥)",

                            value: formattedValue.l2tp,
                        }
                    ]
                }

                context.commit('FORMAT', formatList)

            } catch (e) {
                console.error('动态导入模块出错:', e);
            }
        },

        async userInfo(context) {
            try {

                const {
                    getUserInfo,
                    getProductInfo
                } = await import("@/api/user.js");

                const response = await getUserInfo();
                if (response.code == 200) {
                    sessionStorage.setItem('userId', response.data.id)
                }
                const res = await getProductInfo();
                if (response.code === 200 && res.code === 200) {
                    let user = {}
                    user = response.data;
                    user.moneyType = res.data.menu;

                    context.commit('USERIFO', user)


                } else {
                    Message.error('用户信息获取失败');
                }
            } catch (error) {
                Message.error('用户信息获取失败');
                console.error("获取用户信息时出错:", error);
            }
        }
    },
    mutations: {
        FORMAT(state, value) {
            state.formatList = value;
        },

        USERIFO(state, value) {

            state.user = value;
        },

        SETUSER(state, value) {
            state.user = value;
        },
        updateisScale(state) {
            state.isScale = false;
        }
    },
    state: {
        user: null,
        formatList: [],
        accountType: 1,
        tabPosition: "nodeA",
        announceShow: localStorage.getItem("announceShow") === "true",

    },
    getters: {

    },
}